/**
 * TAK Protocol protobuf JSON descriptor.
 *
 * This is a hand-transcribed JSON representation of the .proto files from
 * /proto/ (takmessage.proto, cotevent.proto, detail.proto, contact.proto,
 * group.proto, precisionlocation.proto, status.proto, takv.proto,
 * track.proto, takcontrol.proto).
 *
 * Used with protobufjs Root.fromJSON() so we can encode/decode TAK messages
 * in the browser without loading .proto files from the filesystem.
 */
export const TAK_PROTO_DESCRIPTOR = {
    nested: {
        atakmap: {
            nested: {
                commoncommo: {
                    nested: {
                        protobuf: {
                            nested: {
                                v1: {
                                    nested: {
                                        TakMessage: {
                                            fields: {
                                                takControl: { type: "TakControl", id: 1 },
                                                cotEvent: { type: "CotEvent", id: 2 },
                                            },
                                        },
                                        TakControl: {
                                            fields: {
                                                minProtoVersion: { type: "uint32", id: 1 },
                                                maxProtoVersion: { type: "uint32", id: 2 },
                                                contactUid: { type: "string", id: 3 },
                                            },
                                        },
                                        CotEvent: {
                                            fields: {
                                                type: { type: "string", id: 1 },
                                                access: { type: "string", id: 2 },
                                                qos: { type: "string", id: 3 },
                                                opex: { type: "string", id: 4 },
                                                uid: { type: "string", id: 5 },
                                                sendTime: { type: "uint64", id: 6 },
                                                startTime: { type: "uint64", id: 7 },
                                                staleTime: { type: "uint64", id: 8 },
                                                how: { type: "string", id: 9 },
                                                lat: { type: "double", id: 10 },
                                                lon: { type: "double", id: 11 },
                                                hae: { type: "double", id: 12 },
                                                ce: { type: "double", id: 13 },
                                                le: { type: "double", id: 14 },
                                                detail: { type: "Detail", id: 15 },
                                            },
                                        },
                                        Detail: {
                                            fields: {
                                                xmlDetail: { type: "string", id: 1 },
                                                contact: { type: "Contact", id: 2 },
                                                group: { type: "Group", id: 3 },
                                                precisionLocation: { type: "PrecisionLocation", id: 4 },
                                                status: { type: "Status", id: 5 },
                                                takv: { type: "Takv", id: 6 },
                                                track: { type: "Track", id: 7 },
                                            },
                                        },
                                        Contact: {
                                            fields: {
                                                endpoint: { type: "string", id: 1 },
                                                callsign: { type: "string", id: 2 },
                                            },
                                        },
                                        Group: {
                                            fields: {
                                                name: { type: "string", id: 1 },
                                                role: { type: "string", id: 2 },
                                            },
                                        },
                                        PrecisionLocation: {
                                            fields: {
                                                geopointsrc: { type: "string", id: 1 },
                                                altsrc: { type: "string", id: 2 },
                                            },
                                        },
                                        Status: {
                                            fields: {
                                                battery: { type: "uint32", id: 1 },
                                            },
                                        },
                                        Takv: {
                                            fields: {
                                                device: { type: "string", id: 1 },
                                                platform: { type: "string", id: 2 },
                                                os: { type: "string", id: 3 },
                                                version: { type: "string", id: 4 },
                                            },
                                        },
                                        Track: {
                                            fields: {
                                                speed: { type: "double", id: 1 },
                                                course: { type: "double", id: 2 },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
};
